import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import PartnerFileBulkListItem from './PartnerFileBulkListItem';
import PartnerFileBulkActions from './PartnerFileBulkActions';
import PaginationWrapper from 'components/common/PaginationWrapper';

function PartnerFileBulkList({
  partnerFileBulkList,
  allPartnersSelected,
  anyPartnerSelected,
  onSelectAllPartners,
  pager,
  setPager,
  totalCount,
  setPartners,
  onCheckBoxChange,
  onAddBulkFile,
  saving
}) {
  const pagerUpdater = useCallback(
    (prop, value) => {
      return prop === 'pageSize' ? { ...pager, [prop]: value, page: 1 } : { ...pager, [prop]: value };
    },
    [pager]
  );

  const onChangeRowsPerPage = useCallback(
    pageSize => {
      setPager(pagerUpdater('pageSize', pageSize));
      setPartners([]);
    },
    [pagerUpdater, setPager, setPartners]
  );

  const onChangePage = useCallback(
    page => {
      setPager(pagerUpdater('page', ++page));
    },
    [pagerUpdater, setPager]
  );

  return (
    <Grid container gap={2}>
      <Grid item xs={12}>
        <PartnerFileBulkActions
          allPartnersSelected={allPartnersSelected}
          anyPartnerSelected={anyPartnerSelected}
          onSelectAllPartners={onSelectAllPartners}
          onAddBulkFile={onAddBulkFile}
          saving={saving}
        />
      </Grid>
      {partnerFileBulkList?.map(partner => (
        <Grid key={partner.partnerId} item xs={12}>
          <PartnerFileBulkListItem partner={partner} onCheckBoxChange={onCheckBoxChange} saving={saving} />
        </Grid>
      ))}
      <Grid item xs={12}>
        <PaginationWrapper
          count={totalCount}
          pageSize={pager.pageSize}
          page={pager.page}
          onRowsPerPageChange={onChangeRowsPerPage}
          onPageChange={onChangePage}
          buttonsDisabled={saving}
        />
      </Grid>
    </Grid>
  );
}

PartnerFileBulkList.propTypes = {
  partnerFileBulkList: PropTypes.array,
  allPartnersSelected: PropTypes.bool.isRequired,
  anyPartnerSelected: PropTypes.bool.isRequired,
  onSelectAllPartners: PropTypes.func.isRequired,
  pager: PropTypes.number.isRequired,
  setPager: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  setPartners: PropTypes.func.isRequired,
  onCheckBoxChange: PropTypes.func.isRequired,
  onAddBulkFile: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default PartnerFileBulkList;
